import { Observable } from 'rxjs/Observable';
import * as api from 'shared/services/api';
import { cartService } from 'services/CartService';
import { IProductData, IInstallment } from '../interfaces/IProductData';
import { parameterService } from './ParameterService';

export interface IInstallments {
  [key: string]: {
    installments: IInstallment[];
    maxInstallments: number;
    minValue: number;
  };
}

const cache: {
  [key: string]: IInstallments
} = {};

export const warmapCache = (product: Partial<IProductData>) => {

  if (!product.installments || product.installments.length === 0) {
    return;
  }

  const key = JSON.stringify([product.price]);

  cache[key] = {
    [product.price]: {
      installments: product.installments,
      maxInstallments: product.installments[product.installments.length - 1].installment,
      minValue: product.installments[product.installments.length - 1].value,
    }
  };

};

export const getInstallments = (values: number[]): Observable<IInstallments> => {

  const key = JSON.stringify(values);

  if (cache[key]) {
    return Observable.of(cache[key]);
  }

  return cartService.getCart()
    .combineLatest(parameterService.getAll())
    .switchMap(([cart, parameters]) => {
      return api.post<IInstallments>('/installments/generate', {
        values,
        parameters
      })
        .map(data => {
          cache[key] = data;
          return data;
        });
    });
};



// WEBPACK FOOTER //
// ./src/services/InstallmentsService.ts